import { render, staticRenderFns } from "./ModalFormProduct.vue?vue&type=template&id=19d9240c&scoped=true&"
import script from "./ModalFormProduct.vue?vue&type=script&lang=js&"
export * from "./ModalFormProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d9240c",
  null
  
)

export default component.exports